import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import { ListDivider } from 'rmwc/List';
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';

import SerializeForm from 'form-serialize'

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';

import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';

import StatusMessage from '../../util/StatusMessage'


class TPOUpdateModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      open: false,
      errorMsg: '',
      data: {
        'certification':'TPO',
        'message':'',
        'firstName': '',
        'lastName': '',
        'email': '',
        'userId': '',
        'personalInfoId': '',
        'tpoCertId': '',
        'testcenters': [],
        'testCenterId': '',
        'testCenterName': '',
        'testCenterCountryId': '',
        'testTrackPrimaryList': [],
        'testTrackPrimaryId': '',
        'testTrackPrimaryName':'',
        'testTrackOptionFirstList': [],
        'testTrackOptionFirstId': '',
        'testTrackOptionFirstName':'',
        'testTrackOptionSecondList': [],
        'testTrackOptionSecondId': '',
        'testTrackOptionSecondName':'',
      }
    }
    
  }


  componentDidMount() {   

    let data = Object.assign({}, this.state.data)
    this.setState({open: true})

    api.getTestCenters('').then((result) => {
      data.testcenters = result
      return api.fetchAdminTPORegDetail(this.props.user.accessToken, this.props.selectedTPO)
    }).then((result) =>{
      const { status, errors} = result
      if (status === 'success') {
        data.firstName = result.data.firstName
        data.lastName = result.data.lastName
        data.email = result.data.email
        data.testCenterId = result.data.testCenterId
        data.testTrackPrimaryId = result.data.trackNumber1Id
        data.testTrackOptionFirstId = result.data.trackNumber2Id
        data.testTrackOptionSecondId = result.data.trackNumber3Id
        data.testCenterCountryId = result.data.testCenterCountryId.toString()
        data.tpoCertId = result.data.tpoCertId
        data.userId = result.data.userId
        data.personalInfoId = result.data.personalInfoId
      }
       return api.getTPOTestTracks('', data.testCenterCountryId)
      }).then((testTrackPrimaryList) => {
        data.testTrackPrimaryList = testTrackPrimaryList
        data.testTrackOptionFirstList = testTrackPrimaryList
        data.testTrackOptionSecondList = testTrackPrimaryList
        this.setState({data: data})
      })
 }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = (e) => {
    this.setState({ open: false });
    this.props.onClose()
  };

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleTestCenterChange = (event) => {

    let data = Object.assign({}, this.state.data)
    
    if(event.target.value){
      let selectedOption = event.target.value
      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index]
      data.testCenterId = selectedOption
      data.testCenterName = optionElement.getAttribute('data-name')
      data.testCenterCountryId = optionElement.getAttribute('date-countryid')
      this.setState({data: data})
       
      if(data.testCenterCountryId !== this.state.data.testCenterCountryId){
        
        api.getTPOTestTracks('', data.testCenterCountryId)
          .then((testTrackPrimaryList) => {
            data.testTrackPrimaryList = testTrackPrimaryList
            data.testTrackPrimaryId = ''
            data.testTrackPrimaryName = ''
            data.testTrackOptionFirstList = testTrackPrimaryList
            data.testTrackOptionFirstId = ''
            data.testTrackOptionFirstName = ''
            data.testTrackOptionSecondList = testTrackPrimaryList
            data.testTrackOptionSecondId = ''
            data.testTrackOptionSecondName = ''
            this.setState({data: data})
        })
         
      }
      else{
       
      }
    }
    else{
       data.testcenterId = ''
       data.testCenterName = ''
       data.testCenterCountryId = ''
       data.testTrackPrimaryList = []
       data.testTrackPrimaryId = ''
       data.testTrackPrimaryName = ''
       data.testTrackOptionFirstList = []
       data.testTrackOptionFirstId = ''
       data.testTrackOptionFirstName = ''
       data.testTrackOptionSecondList = []
       data.testTrackOptionSecondId = ''
       data.testTrackOptionSecondName = ''
       this.setState({data: data})
    }
      
  }

  handleTestTrackPrimaryChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      data.testTrackPrimaryId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackPrimaryName = optionElement.getAttribute('data-name')
    }
    else{
      data.testTrackPrimaryId = ''
      data.testTrackPrimaryName = ''
    }
    this.setState({data: data})
  }

  handleTestTrackOptionFirstChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      data.testTrackOptionFirstId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackOptionFirstName = optionElement.getAttribute('data-name')
    }
    else{
      data.testTrackOptionFirstId = ''
      data.testTrackOptionFirstName = ''
    }
    this.setState({data: data})

  }

  handleTestTrackOptionSecondChange = (event) =>{

    let data = Object.assign({}, this.state.data)
    if(event.target.value){

      data.testTrackOptionSecondId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackOptionSecondName = optionElement.getAttribute('data-name')
    }
    else{
      data.testTrackOptionSecondId = ''
      data.testTrackOptionSecondName = ''
    }
    this.setState({data: data})

  }


  updateRegistration = () => {
    let data = Object.assign({}, this.state.data)

    let apiInput = {
      'tpo_certification': {
        'tpo_cert_id': data.tpoCertId,
        'test_center_id': data.testCenterId,
      },
      'tpo_certification_detail': {
      'test_track_primary': data.testTrackPrimaryId,
        'test_track_first_option': data.testTrackOptionFirstId,
        'test_track_second_option': data.testTrackOptionSecondId,
      },
      'user':{
        'user_id': data.userId,
        'email': data.email,
      },
      'personal_info':{
        'personal_info_id': data.personalInfoId,
        'first_name': data.firstName,
        'last_name': data.lastName,
      }, 
    }

    api.adminUpdateTPORegistration(this.props.user.accessToken,apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          this.setState({ errorMsg: 'Updated Registration data. Please go back to main page refresh and validate' })
        }
        else{
          this.setState({ errorMsg: result.data })
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
  }

  render() {
      
      let onCloseModal = this.onCloseModal
      return (
        <Dialog
         open={this.props.updateOpen}
         onClose={((e) => onCloseModal(e))}
         >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>TPO Details - Update for {this.props.selectedTPO}</DialogHeaderTitle>
        </DialogHeader>
        <DialogBody>
          <TextField label="First Name" className="two-col-input" autoComplete="off" name="firstName" onChange={this.onInputChange} value={this.state.data.firstName}/>
          <br/>
          
          <TextField label="Last Name" className="two-col-input" autoComplete="off"  name="lastName" onChange={this.onInputChange} value={this.state.data.lastName}/>
          <br/>
          <TextField label="Email" className="two-col-input" autoComplete="off"  name="email" onChange={this.onInputChange} value={this.state.data.email} onBlur={this.emailValidate}/>
          <br/>
          <Select
            name="testcenter"
            onChange={this.handleTestCenterChange}
            value={this.state.data.testCenterId}
            className="two-col-input"
            placeholder="--- Select Test City ---"
          >
            {this.state.data.testcenters.map(testcenter => (
              <option key={testcenter.id} value={testcenter.id} data-name={testcenter.name}
                date-countryid = {testcenter.country_id}>
                {testcenter.name}
              </option>
            ))}
          </Select>
          <br/>
          <br/>
           <Select
            name="testTrackPrimary"
            onChange={this.handleTestTrackPrimaryChange}
            value={this.state.data.testTrackPrimaryId}
            className="two-col-input"
            placeholder="--- Select Primary Track ---"
          >
            {this.state.data.testTrackPrimaryList.map(trackPrimary => (
              <option key={trackPrimary.id} value={trackPrimary.id} data-name={trackPrimary.name}>
                {trackPrimary.name}
              </option>
            ))}
          </Select>
          <br/>
           <Select
            name="testTrackOptionFirst"
            onChange={this.handleTestTrackOptionFirstChange}
            value={this.state.data.testTrackOptionFirstId}
            className="two-col-input"
            placeholder="--- Select Option First Track ---"
          >
            {this.state.data.testTrackOptionFirstList.map(level => (
              <option key={level.id} value={level.id} data-name={level.name}>
                {level.name}
              </option>
            ))}
          </Select>
          <br/>
          <Select
            name="testTrackOptionSecond"
            onChange={this.handleTestTrackOptionSecondChange}
            value={this.state.data.testTrackOptionSecondId}
            className="two-col-input"
            placeholder="--- Select Option Second Track ---"
          >
            {this.state.data.testTrackOptionSecondList.map(level => (
              <option key={level.id} value={level.id} data-name={level.name}>
                {level.name}
              </option>
            ))}
          </Select>
        </DialogBody>
        <DialogFooter>
            <StatusMessage error_msg = {this.state.errorMsg}/>
            <DialogFooterButton cancel>Cancel</DialogFooterButton>
            <DialogFooterButton onClick={this.updateRegistration}>Update</DialogFooterButton>
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
      )
    
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPOUpdateModal);


// WEBPACK FOOTER //
// ./src/views/admin/TPOUpdateModal.jsx